import BarChart from "../../components/BarChart";
import Header from "../../components/Header";
import { Box } from "@mui/material";

const Index = () => {
  return (
    <Box m="20px" sx={{ marginTop: "100px" }}>
      <Header title="Bar Chart" subtitle="Simple Bar Chart" />
      <Box height={"75vh"}>
        <BarChart data={[]} />
      </Box>
    </Box>
  );
};

export default Index;
